<template>
  <div class="portal">
    <!--
    <appCA      v-else-if="userGroupID === 2" />
    <appAgency  v-else-if="userGroupID === 3" />
    <appTerminal  v-else-if="userGroupID === 5" />
    -->
    <appDecsa   v-if="userGroupID === 1" />
    <appCarrier v-else-if="userGroupID === 4" />
    <appConsignee v-else-if="userGroupID === 6" />
    <appPublic  v-else />
  </div>
</template>
<script>
import appDecsa from "@/components/portal/decsa/Main";
//import appCA from "@/components/portal/ca/Main";
//import appAgency from "@/components/portal/agency/Main";
import appCarrier from "@/components/portal/carrier/Main";
//import appTerminal from "@/pages/ModuleNotReady.vue";
import appConsignee from "@/components/portal/customer/Main";
import appPublic from "@/components/portal/public/Main";

export default {
  name: "portal",
  components: {
    appPublic,
    appDecsa,
    //appCA,
    //appAgency,
    appCarrier,
    //appTerminal,
    appConsignee,
  },
  computed: {
    userGroupID(){
      return this.$store.state.authLevel;
    }
  },
};
</script>
